<template>
    <router-view></router-view>
</template>

<script>

    import ApiRouter from "./components/Systems/ApiRouter";
    import FavoriteKit from "./components/Helper/FavoriteKit";
    import ViewingHistoryKit from "./components/Helper/ViewingHistoryKit";

    export default {
        name: 'app',
        mixins: [ApiRouter, FavoriteKit, ViewingHistoryKit],
        metaInfo: function() {
            return {
                title: this.$t('siteInfo.title'),
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: this.$t('siteInfo.description'),
                    },
                    {
                        vmid: 'og-title',
                        property: 'og:title',
                        content: this.$t('siteInfo.title'),
                    },
                    {
                        vmid: 'og-type',
                        property: 'og:type',
                        content: 'website',
                    },
                    {
                        vmid: 'og-description',
                        property: 'og:description',
                        content: this.$t('siteInfo.description'),
                    },
                    {
                        vmid: 'og-url',
                        property: 'og:url',
                        content: location.href,
                    },
                    {
                        vmid: 'og-image',
                        property: 'og:image',
                        content: '../img/topimage01.jpg',
                    },
                    {
                        vmid: 'og-site-name',
                        property: 'og:site_name',
                        content: this.$t('siteInfo.title'),
                    },
                    {
                        vmid: 'og-locale',
                        property: 'og:locale',
                        content: this.$i18n.locale,
                    }
                ]
            }
        },
        created: function () {
            this.changeLang();
            this.loadBasicData();
            this.loadCaches();
        },
        methods: {
            changeLang: function () {
                const currentPath = window.location.pathname;

                const pathSegments = currentPath.split('/').filter(Boolean);
                const langFromUrl = (pathSegments.length > 0 && ['ja', 'en'].includes(pathSegments[0])) ? pathSegments[0] : null;

                let lang = navigator.language
                    || navigator.userLanguage
                    || navigator.browserLanguage;
                lang = lang.substr(0, 2);
                lang = lang === 'ja' ? 'ja' : 'en';

                this.$i18n.locale = langFromUrl || this.$route.params.lang || lang;
                document.documentElement.lang = this.$i18n.locale;

                if (currentPath === '/') {
                    this.$router.replace({ name: 'Top', params: { lang: this.$i18n.locale } });
                }
            },
            loadBasicData: function () {
                window.axios.get(this.routes.categories)
                    .then((response) => {
                        this.$root.caches.categories = response.data;
                    });
                // .catch((error) => {
                //     this.handleErrorStatusCodes(error);
                // })
            },
            loadCaches: function () {
                this.$root.caches.favoriteContents = this.getFavoriteContents();
                this.$root.caches.viewingHistoryOfContents = this.getViewingHistories();
            }
        }
    }
</script>

<style src="./styles/style.scss" lang="scss"></style>
